import * as bodyPix from "@tensorflow-models/body-pix";
import { LocalUserState } from "../../common";
import LocalVideoEffect from "./LocalVideoEffect";
import { IVirtualBackgroundEffect } from "./types";

export { IVirtualBackgroundEffect };

let effectInstance: LocalVideoEffect | undefined;
/** @deprecated */
export function getLocalVideoEffect(video: HTMLVideoElement, canvas: HTMLCanvasElement, localUser: LocalUserState) {
    if (effectInstance === undefined) {
        effectInstance = new LocalVideoEffect(video, canvas, localUser);
    }
    return effectInstance;
}

/**
 * Creates a new instance of JitsiStreamBlurEffect. This loads the bodyPix model that is used to
 * extract person segmentation.
 *
 * @returns {Promise<JitsiStreamBlurEffect>}
 */
export async function createBlurEffect(outputCanvasEl: HTMLCanvasElement) {
    if (!MediaStreamTrack.prototype.getSettings && !MediaStreamTrack.prototype.getConstraints) {
        throw new Error("JitsiStreamBlurEffect not supported!");
    }

    if (typeof window === "undefined") {
        return;
    }

    const JitsiStreamBlurEffect = (await import("./JitsiStreamBlurEffect")).default;

    // An output stride of 16 and a multiplier of 0.5 are used for improved
    // performance on a larger range of CPUs.
    const bpModel = await bodyPix.load({
        architecture: "MobileNetV1",
        outputStride: 16,
        multiplier: 0.5,
        quantBytes: 2,
    });

    return new JitsiStreamBlurEffect(bpModel, outputCanvasEl);
}

export async function getVirtualBackgroundEffect(
    video: HTMLVideoElement,
    canvas: HTMLCanvasElement,
    localUser: LocalUserState
): Promise<IVirtualBackgroundEffect | undefined> {
    if (typeof window === "undefined") {
        return;
    }

    const VirtualBackgroundEffect = (await import("./VirtualBackgroundEffect")).default;
    return new VirtualBackgroundEffect(video, canvas, localUser);
}
